document.addEventListener(
  "DOMContentLoaded",
  function () {
    // ■ オウンドメディア記事用の目次自動生成機能 STR
    const butlrCreateToc = () => {

      // 目次リスト追加対象となる要素を指定
      // ※ここもバトラー用のCSSに修正する
      const toc = document.querySelector("#article-toc .body");
      // 対象見出しタグセット
      // const headings = document.querySelectorAll('h2[data-pf-type="Heading2"]');
      const headings = document.querySelectorAll('h2.butlr-header');

      if (!toc || headings.length === 0) {
        return;
      }

      const list = document.createElement("ol");
      toc.appendChild(list);

      const order = [];
      const stack = [{ level: 1, element: list }];

      // 事前処理(次のHタグのレベルを知るために必要)
      headings.forEach((heading) => {
        const level = parseInt(heading.tagName.substring(1));
        order.push(level);
      });

      // 目次生成のメイン処理
      headings.forEach((heading, i) => {
        if (heading.textContent == "関連記事") return; // 目次に表示しないHタグは処理しない
        const level = parseInt(heading.tagName.substring(1));
        const next = order[i + 1];
        const li = document.createElement("li");
        const a = document.createElement("a");
        const id = "toc-" + (i + 1);
        const ol = document.createElement("ol");

        // 目次要素の生成
        a.textContent = heading.textContent;
        a.href = `#${id}`;
        li.appendChild(a);
        if (level < next) {
          li.appendChild(ol);
        }

        // リンク先idの追加
        heading.id = id;

        // 階層構造の生成
        // 【ロジックについて】
        // stack = [ {level: 1, element: list}, {level: 2, element: ol(第2階層)}, {level: 3, element: ol(new)} ]
        // 上記のように、階層ごとのol要素ができるので、そこに追加していくイメージ
        let parent;
        do {
          parent = stack.pop();
        } while (parent.level >= level); //この条件否定＝階層下がる　の場合は、新しく設置されたol(前のループ処理で設置)にli要素追加する。
        parent.element.appendChild(li); //【重要】ここで生成した目次リスト(li)要素1つを追加
        stack.push(parent);
        stack.push({ level: level, element: ol });
      });
    };


    // ■ アコーディオン開閉機能 STR
    const butlrToggleAccordion = () => {
      const acc_content = Array.from(document.querySelectorAll('.butlr-accordion-title'));

      acc_content.forEach((item) => {
        item.addEventListener('click', function() {
          this.classList.toggle('active');
          const acc_content_ele = this.nextElementSibling;
          if (acc_content_ele.style.maxHeight) {
            acc_content_ele.style.maxHeight = null;
          } else {
            acc_content_ele.style.maxHeight = acc_content_ele.scrollHeight + 'px';
          }
        });
      });
    }


    // 説明部分のモーダル化機能追記
    const butlrCreateProductDescModal = () => {
      let element = document.querySelectorAll(".butlr-popular-reason-container");
      if (element.length === 0) return;

      let template = document.getElementById("butlr-article");
      let modal = document.createElement("div");
      modal.id = "butlr-modal";
      modal.className = "butlr-modal";
      modal.innerHTML =
        "<div class='butlr-modal-content'><div id='butlr-modal-body' class='butlr-modal-body'><span id='butlr-modal-close' class='butlr-modal-close'>×</span></div></div>";
        template.appendChild(modal);

      // 「詳しく見る」ボタンのすべての要素を取得
      let open_btn = document.querySelectorAll(".butlr-modal-open-button");

      // 各要素にイベントリスナーを追加
      open_btn.forEach((e) => {
        e.addEventListener("click", function () {
          // モーダルの方に説明コンテンツを追加
          const clone_ele = this.nextElementSibling.cloneNode(true);
          const modal_body_ele = document.getElementById("butlr-modal-body");
          modal_body_ele.appendChild(clone_ele);

          // モーダル表示
          modal.style.display = "block";
        });
      });

      // 閉じるボタンクリック時にモーダル閉じる
      document.getElementById("butlr-modal-close").onclick = (e) => {
        modal.style.display = "none";
        // #modalCloseの次要素（追加した説明コンテンツ）を削除
        e.target.parentNode.querySelector(".butlr-popular-reason-container").remove();
      };

      // （PCのみ）モーダルコンテンツ外がクリックされたとき、モーダル閉じる
      modal.addEventListener("click", (e) => {
        if (!e.target.closest(".butlr-modal-body")) {
          modal.style.display = "none";
          e.target.querySelector(".butlr-popular-reason-container").remove();
        }
      });
    };

    // 実行
    butlrCreateToc(); // 目次作成
    butlrToggleAccordion();  // アコーディオン作成
    butlrCreateProductDescModal(); // モーダル表示
  },
  false
);
